<template>
  <div id="mobileApp">
    <div class="header_mobile">
        <div class="logo_mobile">
        <img src="./assets/toplogo.png" alt style="margin-top:2.1875rem"/>
      </div>
      <img class = "img_menu" :src=drawerIcon alt @click="showMenu()"/>
    </div>
    <div class="content"><router-view/>

    <div class="footer_mobile">
    <img class = "footlogo_mobile" src="./assets/footlogo.png" alt />
    <div style="display: flex;flex-flow:column;text-align: center;margin-left: 4.6875rem;vertical-align: middle;">
    <span style="font-size: 1.5rem;color: #FFFFFF; text-align: left;margin-top: 4.375rem;">联系方式：<br/><font style="color: #AAAAAA;">business@yongxintechhk.com</font></span>
    <span style="font-size: 1.5rem;color: #FFFFFF; text-align: left;margin-top: 2.5rem;">联系地址：<br/><font style="color: #AAAAAA;">S8 9F W LUXE 5 ON YIU STREET SHA TIN NT HK</font></span>
    </div>
    </div>
    </div>

    <div class="menu" v-if="drawer" @click="dismissMenu($event)">
    <el-menu
        :default-active="$route.path"
        mode="vertical"
        @select="handleSelect"
        :router="router"
        class="el_menu_mobile">
        <el-menu-item index="/">公司简介</el-menu-item>
        <el-menu-item index="/culture">企业文化</el-menu-item>
        <el-menu-item index="/welfare">员工福利</el-menu-item>
        <el-menu-item index="/advance">学习发展</el-menu-item>
         <!-- <el-submenu>
           <template slot="title">加入我们</template>
        <el-menu-item index="/applyProcess">应聘流程</el-menu-item>
        <el-menu-item index="/positions">职位速递</el-menu-item>
        </el-submenu> -->
                <el-menu-item index="/applyProcess">应聘流程</el-menu-item>
        <el-menu-item index="/contactUs">联系我们</el-menu-item>
      </el-menu>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      router: true,
      activeIndex: "/",
      drawer: false,
      drawerIcon:''
    };
  },

  mounted (){
    this.activeIndex = '/'
    this.drawerIcon = require('./assets/icon_app_menu.png')
  },
  activated() {
    this.drawerIcon = require('./assets/icon_app_menu.png')
  },
  methods: {
    handleSelect(key) {
      this.drawer =false
      this.drawerIcon = require('./assets/icon_app_menu.png')
    },
    showMenu(){
      this.drawer = !this.drawer;
      if(this.drawer){
        this.drawerIcon = require('./assets/icon_app_menu_close.png')
      }else{
        this.drawerIcon = require('./assets/icon_app_menu.png')
      }
    },
    dismissMenu(ev){
        if(this.drawer && ((ev.target==null || ev.target==undefined || ev.target._prevClass==null ||ev.target._prevClass==undefined) ||'menu'===ev.target._prevClass)){
           this.drawer = false;
           this.drawerIcon = require('./assets/icon_app_menu.png')
    }
  },
  }
};
</script>

<style scoped>
* {
  padding: 0;
  margin: 0;
}
html,
body {
  height: 100%;
}
#mobileApp {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  margin: 0px;
  padding: 0px;
  overflow: scroll;
  height: 100%;
}

.content{
   height: calc(100% - 10rem);
   overflow:scroll;
   position: relative;
}
.header_mobile{
  position: relative;
  text-align: center;
  height: 10rem;
}
.img_menu{
  width:2.5rem;
  height:2.5rem;
  position: absolute;
  right: 1.75rem;
  top: 4rem;
}
.logo_mobile{
  display: inline-block;
  width:fit-content;
  float:none;
}

.logo_mobile img {
  width: 5.9375rem;
  line-height: 5.625rem;
}
.footer_mobile{
  height: 20.9375rem;
  background-color: #1a1a1a;
}
.footlogo_mobile{
  width:8.4375rem;
  height:8.125rem;
  float: right;
  margin-right: 4.6875rem;
  margin-top: 8.5rem;
}
.menu{
background-color:rgba(00, 00, 00, 0.5);
width:100%;
height: calc(100% - 10rem);
position: absolute;
right: 0px;
top: 10rem;
z-index: 999;
}
.el_menu_mobile {
    background-color:#fff
}

.el_menu_mobile /deep/ .el-menu-item {
    text-align: left;
    font-size: 1.5rem;
    line-height: 3.75rem;
    height: 4.875rem;
    margin: 0;
    color: #1A1A1A;
    font-weight: normal;
    background-color: #fff;
    border-bottom: 1px solid rgba(26, 26, 26, 0.1);
    padding-top: 0.5625rem;
    padding-bottom: 0.5625rem;
}


.el_menu_mobile /deep/ .el-menu-item.is-active {
  color: #fff;
  background-color: #0090E3!important;
}

/* active-text-color="" */
.el_menu_mobile /deep/.el-menu-item:hover {
  color: #fff;
  background-color: #0090E3!important;
}
.el_menu_mobile /deep/ .el-submenu__title{
    text-align: left;
    font-size: 1.5rem;
    line-height: 3.75rem;
    height: 4.875rem;
    padding-top: 0.5625rem;
    padding-bottom: 0.5625rem;
    margin: 0;
    border-bottom: 1px solid rgba(26, 26, 26, 0.1);
    color: #1A1A1A;
    font-weight: normal;
}

.el_menu_mobile /deep/ .el-submenu__title.is-active{
  color: #fff;
  background-color: #0090E3!important;
}
.el_menu_mobile /deep/ .el-submenu__title:hover{
  color: #fff;
  background-color: #0090E3!important;
}
</style>



// WEBPACK FOOTER //
// src/MobileApp.vue